// src/app-config.js
// ✅ Cloudflare Pages build 需要這個檔案存在，避免 Module not found
// 你之後再把真正的設定填進來即可。

const APP_CONFIG = {
  APP_ID: "chengkai-math-app",

  // Firebase（先留空也不會讓 build 失敗；但執行會需要你填）
  FIREBASE: {
    apiKey: "",
    authDomain: "",
    projectId: "",
    storageBucket: "",
    messagingSenderId: "",
    appId: "",
    measurementId: "",
  },

  // 你若有 API endpoint / worker
  API_BASE: "",
};

export default APP_CONFIG;
export { APP_CONFIG };
